import React from 'react';

import { useMutation } from '@apollo/react-hooks';
import { useHistory } from 'react-router-dom';

import {
  Typography,
  Button,
  InputAdornment,
  IconButton
} from '@material-ui/core';

import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

import { DOMAIN } from 'config';

import { SimpleInput, LineOnSidesLink } from 'components';
import { useField, useForm } from 'custom-hooks';
import { SIGNIN_MUTATION } from 'graphql/mutations/auth';
import { isRequired, isEmail, isValidPassword } from 'utils/validators';

import useStyles from './styles';

const SignIn = () => {
  const classes = useStyles();

  const history = useHistory();

  const [signIn] = useMutation(SIGNIN_MUTATION);

  const loginForm = useForm({
    onSubmit: (formData, formValid) => {
      if (!formValid) return;

      signIn({
        variables: { email: formData.email, password: formData.password }
      }).then(
        () => {
          window.location = DOMAIN;
          // history.push('/');
        },
        () => {
          passwordField.setError(
            'Email or password is incorrect, please try again'
          );
          emailField.setError('');
        }
      );
    }
  });

  const [showPassword, setShowPassword] = React.useState(false);
  const onShowPasswordClick = () => {
    setShowPassword(!showPassword);
  };

  const emailField = useField('email', loginForm, {
    defaultValue: '',
    validations: [
      formData => isRequired(formData.email, 'Email is required'),
      formData => isEmail(formData.email, 'Invalid email')
    ]
  });

  const passwordField = useField('password', loginForm, {
    defaultValue: '',
    validations: [
      formData => isRequired(formData.password, 'Password is required'),
      formData =>
        isValidPassword(
          formData.password,
          'The password must include at least 8 characters with 1 symbol, 1 digit, 1 uppercase letter, 1 lowercase letter'
        )
    ]
  });

  return (
    <div className={classes.wrapper}>
      <Typography className={classes.title} variant="h1">
        Login
      </Typography>
      <form onSubmit={loginForm.handleSubmit}>
        <SimpleInput
          placeholder="Email"
          className={classes.inputIndent}
          label="Email"
          value={emailField.value}
          onChange={emailField.onChange}
          errors={emailField.errors}
          errorText={emailField.errors[0]}
        />
        <SimpleInput
          type={showPassword ? 'text' : 'password'}
          placeholder="Password"
          label="Password"
          endAdornment={
            <InputAdornment position="end">
              <IconButton onClick={onShowPasswordClick}>
                {showPassword ? (
                  <Visibility className={classes.passwordIcon} />
                ) : (
                  <VisibilityOff className={classes.passwordIcon} />
                )}
              </IconButton>
            </InputAdornment>
          }
          value={passwordField.value}
          onChange={passwordField.onChange}
          errors={passwordField.errors}
          errorText={passwordField.errors[0]}
          autoComplete="new-password"
        />
        <Button
          type="submit"
          className={classes.button}
          variant="contained"
          color="primary"
        >
          Login
        </Button>
      </form>
      <LineOnSidesLink path="/password/reset"> Reset password</LineOnSidesLink>
    </div>
  );
};

export default SignIn;
